import axios from 'axios';

export default class LeasingCarCalculator {
  constructor() {
    this.token = "3LT4dTVMoGwRn";
    this.calculator = document.querySelector('[data-calculator]');
    this.calculator_form = document.querySelector('#leasingSingleCar');
    this.current_payment_type = 'leasing';
    this.vw_api_endpoint = 'https://kalkulator.vwbank.pl/vwapi/calculate/';
    this.vw_api_proxy_endpoint = window?.ajax_object?.restUrlVwBankProxy ?? '';
    this.calculator_data = {};
    this.vat = 23;
  }

  init() {
    console.log('leasing single car init');
    let that = this;
    if (!this.checkPageType()) {
      return false;
    }

    this.currentCar = this.setCurrentCar(this.calculator_form.dataset.options);
    this.calculator_form.addEventListener('submit', (e) => {
      e.preventDefault();
      this.getFormData();
      this.reinitPriceSummary();
      this.getCalculateFromVWBank(this.current_payment_type);

      const scroll = document.querySelector('#calculation-results');
      const isMobile = window.innerWidth < 992;

      if (scroll && isMobile) {
        scroll.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });

    // console.log('CURRENT CAR', this.currentCar);
    document.querySelector('[data-summary-car-price]').innerText = parseInt(this.currentCar.model_price) + ' zł brutto';
    document.querySelector('[data-summary-car-price-net]').innerText = parseInt((this.currentCar.model_price * 100) / (100 + this.vat)) + ' zł netto';
    document.querySelector('select[name="'+ this.current_payment_type+'_own-contribution"]').value = 20;
    document.querySelector('select[name="'+ this.current_payment_type+'_limit"]').value = 20;
    document.querySelector('select[name="'+ this.current_payment_type+'_loans"]').value = 36;
    setTimeout(() => {
      that.autoCalculate();
    }, 500);

    this.handleImmediateFinancialInputsChange();
  }

  /**
   * Functionality requested in ticket: https://app.clickup.com/t/8693hkqbb
   * Recalculate the form immediately when the bank parameters change
   * (financing legth, own payment etc.)
   */
  handleImmediateFinancialInputsChange() {
    this.financialInputsContainer = document.querySelector('[data-financial-parameters-inputs]');
    if (!this.financialInputsContainer) {
      return;
    }

    const financialInputs = this.financialInputsContainer.querySelectorAll('select');
    if (!financialInputs) {
      return;
    }

    financialInputs.forEach((input) => {
      input.addEventListener('change', () => {
        /**
         * Let's do it this way instead of `autocalculate()` because the data in the at this point might be missing
         */
        const valid = this.calculator_form.reportValidity();
        if (!valid) {
          return;
        }

        this.calculator_form.dispatchEvent(new Event('submit'));
      });
    })
  }

  reinitPriceSummary() {
    const currentVariantPrice = parseInt(this.calculator_form.dataset.calculatorPrice);
    document.querySelector('[data-summary-car-price]').innerText = parseInt(currentVariantPrice) + ' zł brutto';
    document.querySelector('[data-summary-car-price-net]').innerText = parseInt((currentVariantPrice * 100) / (100 + this.vat)) + ' zł netto';
  }

  setCurrentCar(car_data)
  {
    return JSON.parse(car_data);
  }

  autoCalculate() {
    this.getFormData();
    this.getCalculateFromVWBank('leasing');
  }

  getFormData() {
    // Reset data
    this.calculator_data = {};

    // Set New data
    this.calculator_data = {
      'token': this.token,
      'model': this.calculator_form.dataset.calculatorModel,
      'price': this.calculator_form.dataset.calculatorPrice,
      'km_limit': (this.calculator_form.querySelector('select[name="' + this.current_payment_type + '_limit"]').value) * 1000,
      'rate': this.calculator_form.querySelector('select[name="' + this.current_payment_type + '_loans"]').value,
      'payment': (this.calculator_form.querySelector('select[name="' + this.current_payment_type + '_own-contribution"]').value) / 100,
    };

    console.log('CALCULATOR DATA', this.calculator_data);
  }

  //https://kalkulator.vwbank.pl/vwapi/calculate/skoda_leasing_niskich_rat/
  //https://kalkulator.vwbank.pl/vwapi/calculate/skoda/

  notifyCalculatorStartedLoading() {
    const event = new CustomEvent('calculator-started-loading', {});
    window.dispatchEvent(event);
  }

  notifyCalculatorFinishedLoading() {
    const event = new CustomEvent('calculator-finished-loading', {});
    window.dispatchEvent(event);
  }

  getCalculateFromVWBank(payment_type) {
    this.notifyCalculatorStartedLoading();

    // const endpoint = (payment_type == 'credit') ? 'skoda/' : 'skoda_leasing_niskich_rat/';
    // const url = this.vw_api_endpoint + endpoint;
    const endpoint = (payment_type == 'credit') ? 'skoda' : 'skoda_leasing_niskich_rat';
    const url = this.vw_api_proxy_endpoint + '?endpoint=' + endpoint;

    let formData = new FormData();
    formData.append('token', this.calculator_data.token);
    formData.append('model', this.calculator_data.model);
    formData.append('price', this.calculator_data.price);
    formData.append('km_limit', this.calculator_data.km_limit);
    formData.append('rate', this.calculator_data.rate);
    formData.append('payment', this.calculator_data.payment);

    let config = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      timeout: 20000,
    }

    let that = this;

    axios.post(url, formData, config)
      .then((response) => {

      const rateNetto = response?.data?.content?.rate ?? null;

      if (rateNetto === null) {
        const notAvailable = '------ zł netto';
        document.querySelector('[data-summary-month-loan]').innerText = notAvailable;
        document.querySelector('[data-summary-entry-fee]').innerText = notAvailable;
        document.querySelector('[data-car-attributes]').innerText = that.displaySelectedCarFullNameWithAttributes();
        return;
      }

      const entryFeeBrutto = (parseFloat(that.currentCar.model_price) * parseFloat(that.calculator_form.querySelector('select[name="' + that.current_payment_type + '_own-contribution"]').value)) / 100;
      const entryFeeNetto = entryFeeBrutto * 100 / (100 + that.vat);

      const summaryMonthLoan = that.formatPrice(parseInt(rateNetto)) + ' zł netto';
      const summaryEntryFee = that.formatPrice(parseInt(entryFeeNetto)) + ' zł netto';
      const carAttributes = that.displaySelectedCarFullNameWithAttributes();

      document.querySelector('[data-summary-month-loan]').innerText = summaryMonthLoan;
      document.querySelector('[data-summary-entry-fee]').innerText = summaryEntryFee;
      document.querySelector('[data-car-attributes]').innerText = carAttributes;

      this.notifyRatyCf7Fields({
        summaryMonthLoan,
        summaryEntryFee,
        carAttributes,
      });
    })
    .catch((err) => {
      console.error('Leasing calculator – API error:', err?.response?.data ?? err?.message ?? err);
      const errorMsg = '------ zł netto';
      const monthLoanEl = document.querySelector('[data-summary-month-loan]');
      const entryFeeEl = document.querySelector('[data-summary-entry-fee]');
      if (monthLoanEl) monthLoanEl.innerText = errorMsg;
      if (entryFeeEl) entryFeeEl.innerText = errorMsg;
    })
    .finally(() => {
      this.notifyCalculatorFinishedLoading();
    });
  }

  notifyRatyCf7Fields(bankDetails) {
    let carDetails = Object.assign({}, this.calculator_data);
    carDetails.payment = (100 * carDetails.payment) + '%';

    delete carDetails["token"];

    const calcEvent = new CustomEvent('raty-calculator-changed', {
      detail: {
        bankDetails: bankDetails,
        carDetails: carDetails
      }
    });

    window.dispatchEvent(calcEvent);
  }

  displaySelectedCarFullNameWithAttributes() {
    var model = document.querySelector('select[name="model_id"]');
    var modelName = model.options[model.selectedIndex].text;

    var equipment = document.querySelector('select[name="equipment"]');
    var equipmentName = equipment.options[equipment.selectedIndex].text;

    var engineType = document.querySelector('select[name="engine-type"]');
    var engineTypeName = engineType.options[engineType.selectedIndex].text;

    var engine = document.querySelector('select[name="engine"]');
    var engineName = engine.options[engine.selectedIndex].text;

    return `${modelName} ${equipmentName}, ${engineTypeName}, ${engineName}`;
  }

  animateNumber(elem,value) {
    let current = elem.dataset.currentValue;
    let new_value = parseInt(value);
    elem.innerText = this.formatPrice(new_value) + ' zł';
  }

  formatPrice(price) {
    // format 1000 to 1 000
    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  }


  checkPageType() {
    return this.calculator_form !== null;
  }
}
